import { Trans } from 'react-i18next';
import AdditionalInfo from '../AdditionalInfo';
import { ErrorMessage, FormTextField, LabeledComponent } from '../../index';
import './RowNumberInput.scss';

/**
 * Returns a component horizontal aligned with label, number input and a help icon
 * @param {{
 *  name: string,
 *  defaultValue: string,
 *  inputProps: {},
 *  label: string,
 *  control: *,
 *  disabled?: boolean,
 *  additionalInformation?: string
 *  validationError?: string
 * }} param0
 */
const RowNumberInput = ({
    label,
    control,
    disabled = false,
    additionalInformation = '',
    ...props
}) => {
    const { validationError, ...rest } = props;
    return (
        <LabeledComponent name={label}>
            <FormTextField
                {...rest}
                label=""
                control={control}
                type="number"
                variant="outlined"
                disabled={disabled}
            />
            {additionalInformation && (
                <AdditionalInfo>
                    <Trans>
                        {additionalInformation}
                    </Trans>
                </AdditionalInfo>
            )}
            <ErrorMessage show={!!validationError?.message}>
                {validationError?.message}
            </ErrorMessage>
        </LabeledComponent>
    )
};

export default RowNumberInput;
